export default __webpack_public_path__ + "static/media/stories_sounds_boop.d75015fe.mp3";